import React from 'react';
import PropTypes from 'prop-types';
import { LEARN_MORE } from 'utils/legalUrls';
import useSubscriptionPlanPrices from 'hooks/useSubscriptionPlanPrices';
import { Plans } from '../constants';
import OptionButtons from './OptionButtons';
import PerksList from './PerksList';
import TrialUpgradeDisclaimer from './TrialUpgradeDisclaimer/TrialUpgradeDisclaimer';

const MobileLayout = ({
  handleChange,
  selected,
  onClickUpgrade,
  showAdditionalPerks,
  children,
}) => {
  const { seasonalPrice, annualPrice } = useSubscriptionPlanPrices();
  const displayPerks = annualPrice && seasonalPrice;

  return (
    <div data-testid="ml-trial-container" className="trial-container">
      <div data-testid="ml-title-container" className="title-container">
        <h2>Start Today</h2>
        <h4>Pick your plan below</h4>
      </div>
      <div data-testid="ml-trial-button-container" className="trial-button-container">
        <OptionButtons handleChange={handleChange} selected={selected} />
      </div>
      <div data-testid="ml-trial-list-container" className="trial-list-container">
        {displayPerks && (
          <PerksList
            selected={selected}
            showAdditionalPerks={showAdditionalPerks}
            annualPrice={annualPrice}
            seasonalPrice={seasonalPrice}
          />
        )}
      </div>
      <TrialUpgradeDisclaimer selected={selected} />
      <div className="text-center w-90 margin-0-auto">
        <button
          data-testid="ml-confirm-purchase"
          type="button"
          className="btn btn-lg btn-cta"
          onClick={() => onClickUpgrade()}
        >
          CONFIRM PURCHASE
        </button>
        {children}
      </div>
      <p data-testid="ml-trial-notice" className="trial-notice my-15">
        *Additional $8/box shipping for Canada, Hawaii, Alaska, and Puerto Rico. Sales tax may apply
        (
        <a href={LEARN_MORE} target="_blank" rel="noreferrer">
          learn more
        </a>
        ).
      </p>
    </div>
  );
};

MobileLayout.defaultProps = {
  handleChange: () => null,
  selected: Plans.SEASONAL,
  showAdditionalPerks: false,
};

MobileLayout.propTypes = {
  handleChange: PropTypes.func,
  selected: PropTypes.string,
  showAdditionalPerks: PropTypes.bool,
};

export default MobileLayout;
